export const defined = (value: any) => {
   return value !== undefined && value !== null;
};

export const isArray = (value: any) => {
   return Array.isArray(value);
};

export const isBoolean = (value: any) => {
   return typeof value === 'boolean';
};

export const isNumber = (value: any) => {
   return typeof value === 'number';
};

export const isObject = (value: any) => {
   return value !== undefined && value !== null && !Array.isArray(value) && typeof value === 'object';
};

export const isString = (value: any) => {
   return typeof value === 'string';
};

export const isBlank = (value: string | null | undefined) => {
   return value === undefined || value === null || value.trim().length === 0
};
